import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

export const EmailCapture = {
  Header: lazy(
    () =>
      import(
        'components/direct-sales/email-capture/components/EmailCaptureHeader'
      )
  ),
  Content: lazy(
    () =>
      import(
        'components/direct-sales/email-capture/components/EmailCaptureContent'
      )
  )
};

export default EmailCapture;
